import type { NamespaceTester } from "src/lib/i18next/types.ts";
import { getAllModulesIds } from "src/system/getAllModulesIds.ts";
import { createModuleI18nNamespaces } from "src/system/createModuleI18nNamespaces.ts";

const isModuleNs = (ns: string) => (resource: string) => {
  const namespace = createModuleI18nNamespaces();

  return namespace.layout(resource) === ns;
};

export const module: NamespaceTester = (ns: string, lang: string) => {
  const moduleId = getAllModulesIds().find(isModuleNs(ns));

  if (moduleId) {
    return `src/admin/modules/${moduleId}/locales/${lang}.json`;
  }
};
